// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_LinkRecebimentosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/revenue_conciliation_link_recebimentos/{period_id}
 *
 * Validates input for linking recebimentos to a payroll period.
 */
import { registerContract } from './validate'

export interface Payroll_LinkRecebimentosInput {
recebimento_ids: number[]
}

registerContract('Payroll_LinkRecebimentosInput', {
  recebimento_ids: { type: 'array',   required: true },
})
